/**
 * Generated file, do not edit directly!
 */

/** Spacings define the distances between elements. Use to style gaps, paddings, and margins. The scale follows a non-linear progression that starts with an increase of 2px, grows to 4px, and finally 8px. */

const Size0 = 'var(--dt-spacings-size-0, 0)';
const Size2 = 'var(--dt-spacings-size-2, 2px)';
const Size4 = 'var(--dt-spacings-size-4, 4px)';
const Size6 = 'var(--dt-spacings-size-6, 6px)';
const Size8 = 'var(--dt-spacings-size-8, 8px)';
const Size12 = 'var(--dt-spacings-size-12, 12px)';
const Size16 = 'var(--dt-spacings-size-16, 16px)';
const Size20 = 'var(--dt-spacings-size-20, 20px)';
const Size24 = 'var(--dt-spacings-size-24, 24px)';
const Size28 = 'var(--dt-spacings-size-28, 28px)';
const Size32 = 'var(--dt-spacings-size-32, 32px)';
const Size36 = 'var(--dt-spacings-size-36, 36px)';
const Size40 = 'var(--dt-spacings-size-40, 40px)';
const Size48 = 'var(--dt-spacings-size-48, 48px)';
const Size56 = 'var(--dt-spacings-size-56, 56px)';
const Size64 = 'var(--dt-spacings-size-64, 64px)';
export default {
  /** Css custom property: --dt-spacings-size-0. Value: 0. */
  Size0,
  /** Css custom property: --dt-spacings-size-2. Value: 2px. */
  Size2,
  /** Css custom property: --dt-spacings-size-4. Value: 4px. */
  Size4,
  /** Css custom property: --dt-spacings-size-6. Value: 6px. */
  Size6,
  /** Css custom property: --dt-spacings-size-8. Value: 8px. */
  Size8,
  /** Css custom property: --dt-spacings-size-12. Value: 12px. */
  Size12,
  /** Css custom property: --dt-spacings-size-16. Value: 16px. */
  Size16,
  /** Css custom property: --dt-spacings-size-20. Value: 20px. */
  Size20,
  /** Css custom property: --dt-spacings-size-24. Value: 24px. */
  Size24,
  /** Css custom property: --dt-spacings-size-28. Value: 28px. */
  Size28,
  /** Css custom property: --dt-spacings-size-32. Value: 32px. */
  Size32,
  /** Css custom property: --dt-spacings-size-36. Value: 36px. */
  Size36,
  /** Css custom property: --dt-spacings-size-40. Value: 40px. */
  Size40,
  /** Css custom property: --dt-spacings-size-48. Value: 48px. */
  Size48,
  /** Css custom property: --dt-spacings-size-56. Value: 56px. */
  Size56,
  /** Css custom property: --dt-spacings-size-64. Value: 64px. */
  Size64,
};
